// 404. Until now an unknown URL matched no route at all, so React rendered
// nothing: a typo'd link, a stale bookmark or an old share gave you a white
// page with no chrome and no way back — indistinguishable from the app being
// broken.
//
// It lives INSIDE the shell so the top bar stays and you are still somewhere,
// not nowhere.

import { useCallback } from 'react';
import { useNavigate } from 'react-router';

import robotUrl from '../assets/robot-404.png';
import { Button } from '../ui/Button';

export function NotFoundPage() {
  const navigate = useNavigate();
  // Replace, so Back does not walk you into the dead URL again.
  const home = useCallback(() => navigate('/', { replace: true }), [navigate]);

  return (
    <div className="bz-state-page bz-state-page-fill">
      {/* Decorative: the words carry the meaning, so it is hidden from screen
          readers. Intrinsic size is declared so nothing jumps when it loads. */}
      <img
        className="bz-notfound-art"
        src={robotUrl}
        alt=""
        aria-hidden="true"
        width={350}
        height={350}
      />
      <p className="bz-state-title">Page not found</p>
      <p className="bz-state-sub">
        That link may be broken, or the page may have moved. Your meetings and calls are still
        where you left them.
      </p>
      <Button variant="primary" onClick={home}>
        Back to home
      </Button>
    </div>
  );
}
